import React from 'react'
import { useSelector } from 'react-redux'

import allModals from 'components/Modals'

// Taken from https://stackoverflow.com/questions/35623656/how-can-i-display-a-modal-dialog-in-redux-that-performs-asynchronous-actions/35641680#35641680
const ModalRoot = () => {
  const { openModals } = useSelector(state => state.modals)

  return openModals.map(({ modalType, modalProps }, index) => {
    const SpecificModal = allModals[modalType]
    return <SpecificModal key={index} {...modalProps} />
  })
}

export default ModalRoot
